import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { BookV1 } from '@ilteducation/content-registry-types';
import type { Language } from '@ilteducation/content-ref-data-types';
import useUploadMedia from '@/comp/use-upload-media';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import DropFile from '@/components/base/DropFile.vue';
import { useRefLanguages } from '@/comp/use-ref-languages';
import useMediaFormFeature from '@/comp/use-media-form-feature';

type Props = {
  id: string;
  item?: BookV1;
  title?: string;
  allowedFileNames?: string[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoUploader',
  props: {
    id: null,
    item: null,
    title: null,
    allowedFileNames: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  item?: BookV1;
  title?: string;
  allowedFileNames?: string[];
}

const dropFileRef = ref<InstanceType<typeof DropFile> | null>(null);
const files = ref<File[]>([]);
const selectedLang = ref<Language>();
const pip = ref<boolean>(false);


const { uploadInProgress, uploadBulk } = useUploadMedia();
const { removeMedia } = useMediaFormFeature(props.item);
const upload = async () => {
  console.log('pip: ', pip.value);
  await uploadBulk(props.id, files.value, { subType: 'video', language: selectedLang.value?.languageCode }, pip.value);
  dropFileRef.value?.clearFiles();
};
const removeVideo = async (language: string) => {
  await removeMedia({ subType: 'video', language });
};

const { languages: availableLanguages } = useRefLanguages();

const rules = {
  required: (value: unknown) => !!value || 'This field is required',
};

const getLanguageText = (code: string) =>
  availableLanguages.value?.find((l) => l.languageCode === code)?.language || code;

const updateFiles = (dataFiles: File[]) => {
  files.value = dataFiles;
};

/*
 A spread video covers two pages in one file - `012_013.mp4` for pages 012 and 013 - so the file
 count is lower than the page count. Count the pages covered, not the files.
 */
const coveredPages = computed(
  () => new Set(files.value.flatMap((file) => file.name.split('.')[0].split('_'))).size,
);

const uploadDisabled = computed(
  () => !(coveredPages.value === props.allowedFileNames?.length && selectedLang.value !== undefined),
);

return { __sfc: true,dropFileRef, files, selectedLang, pip, props, uploadInProgress, uploadBulk, removeMedia, upload, removeVideo, availableLanguages, rules, getLanguageText, updateFiles, coveredPages, uploadDisabled, DisableableButton, DropFile }
}

})